import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import '../styles/Sidebar.css';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const navigate = useNavigate();
    const adminRoles = JSON.parse(localStorage.getItem('adminRoles') || '[]');
    const isSignedIn = !!localStorage.getItem('adminToken');

    const handleSignOut = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminId');
        localStorage.removeItem('adminUsername');
        localStorage.removeItem('adminRoles');
        navigate('/');
    };

    const toggleSidebar = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        // Apply class to body for CSS adjustments
        if (newState) {
            document.body.classList.remove('sidebar-closed');
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
            document.body.classList.add('sidebar-closed');
        }
    };

    React.useEffect(() => {
        // Apply initial state on mount
        if (isOpen) {
            document.body.classList.remove('sidebar-closed');
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
            document.body.classList.add('sidebar-closed');
        }
        return () => {
            document.body.classList.remove('sidebar-open', 'sidebar-closed');
        };
    }, [isOpen]);

    const isSuperAdmin = adminRoles.includes('SuperAdmin');
    const isAdmin = adminRoles.includes('Admin');

    const menuItems = [
        { path: '/home', label: 'Dashboard', icon: '🏠', show: isSignedIn },
        { path: '/api-keys', label: 'Manage API Key', icon: '🔑', show: isSuperAdmin },
        { path: '/model-config', label: 'Manage Model Config', icon: '⚙️', show: isAdmin || isSuperAdmin },
        { path: '/manage-model', label: 'Manage Model', icon: '🤖', show: adminRoles.includes('Model_Deployment') },
        { path: '/exported-models', label: 'Exported Models', icon: '💾', show: adminRoles.includes('Model_Export') },
        { path: '/batch-inference-history', label: 'Batch History', icon: '📋', show: adminRoles.includes('Batch_Interference') },
        { path: '/audit-trail', label: 'Audit Trail', icon: '🔍', show: adminRoles.includes('AuditReport') },
        { path: '/drift-report', label: 'Drift Reports', icon: '📈', show: isAdmin || isSuperAdmin },
        { path: '/manage-pipeline', label: 'Manage Pipeline', icon: '📊', show: adminRoles.includes('Model_Training') },
        { path: '/change-password', label: 'Change Password', icon: '🔐', show: isSuperAdmin },
    ];

    return (
        <>
            {isSignedIn && (
                <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
                    <div className="sidebar-header">
                        <h4 className="sidebar-title">ML Studio</h4>
                        <button className="toggle-btn" onClick={toggleSidebar}>
                            {isOpen ? '≡' : '≡'}
                        </button>
                    </div>

                    <nav className="sidebar-menu">
                        {menuItems.map(
                            (item) =>
                                item.show && (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        className="menu-item"
                                        title={item.label}
                                    >
                                        <span className="menu-icon">{item.icon}</span>
                                        {isOpen && <span className="menu-label">{item.label}</span>}
                                    </Link>
                                )
                        )}
                    </nav>

                    <div className="sidebar-footer">
                        <div className="user-info">
                            {isOpen && (
                                <>
                                    <p className="username">
                                        {localStorage.getItem('adminUsername') || 'User'}
                                    </p>
                                    <p className="user-role">
                                        {isSuperAdmin ? '👑 SuperAdmin' : isAdmin ? '👤 Admin' : '👥 User'}
                                    </p>
                                </>
                            )}
                        </div>
                        <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={handleSignOut}
                            className="logout-btn"
                            title="Sign Out"
                        >
                            {isOpen ? '🚪 Sign Out' : '🚪'}
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Sidebar;
